import { setParamsSearch } from './router';

export const canSeePrepTools = (purchase, session) => {
  if (purchase && purchase.voucher) {
    return !purchase.voucher.isCpf || (purchase.voucher.prepToolIds && purchase.voucher.prepToolIds.length > 0);
  }

  return session.get('preparationToolVersions').size;
};

export const getPrevSearch = (session, location) => {
  if (location.state && location.state.prevSearch) {
    return location.state.prevSearch;
  }

  if (!session.size) {
    return;
  }

  return setParamsSearch({
    testTypeIds: [session.get('testType').get('id')],
    showMap: false,
  });
};
